import { Observable } from "rxjs";
import { ITokenPair } from "../features/auth/interface/dto/token-pair";
import { IListDto } from "../interface/dto/list.dto";
import { get } from "./api";

export const searchList = (
    searchText: string,
    tokens: ITokenPair,
    limit?: number,
    access?: boolean,
): Observable<Array<IListDto>> => {
    const queryParams = [
        `query=${encodeURIComponent(searchText)}`,
        limit !== undefined ? `limit=${limit}` : null,
        access !== undefined ? `access=${String(access)}` : null,
    ]
        .filter(Boolean)
        .join("&");

    return get<Array<IListDto>>(`/lists/search?${queryParams}`, {}, tokens);
};
